/// <reference path="../../../WebUI/typings/tsd.d.ts" />

import * as React from "react";
import * as ReactDOM from "react-dom";
import {DialogBase} from "./DialogBase";
import * as View from "../v4/Views/TermsOfServiceDialog";

export class TermsOfServiceDialog extends DialogBase {
    public header: string;
    private options: View.TermsOfServiceDialogProps;

    constructor(options: View.TermsOfServiceDialogProps) {
        super();
        this.options = options;
    }

    protected render(): void {
        var element = React.createElement(View.TermsOfServiceDialog, this.options);
        ReactDOM.render(element, this.$el[0], () => {
            this.init();
        });
    }

    protected init(): void {
        // Call base class method to complete initialization.
        super.init();
    }

    //over-write enter key pressing to avoid users being able to by pass this dialog
    protected onEnterKeyPressed(): boolean {
        return false;
    }
}



// WEBPACK FOOTER //
// ./Client/Dialogs/TermsOfServiceDialog.ts